<template>
  <section v-if="products.length > 0">
      <div class="recently-viewed">
        <h5 v-if="props.label" class="product-tiles-title">{{ props.label }}</h5>
        <div class="product-tiles-wrapper">
          <div class="product-tile" v-for="(product, index) in products" :key="product.id ?? index">
            <div class="product-img-wrapper position-relative">
              <AddToWishlist :prod="product" />
              <ProductImage 
                :product="{ 
                  name: product.name, 
                  image: product.image ?? '', 
                  product_type_id: product.product_type_id,
                  slug: product.slug
                }" 
                :zoom="false"
                imageSize="square-full" 
              />
            </div>
            <div class="product-header">
              <div class="product-name-wrapper">
                <ProductName :product="{ 
                  name: product.name, 
                  slug: product.slug 
                }" />
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>
<script setup>
import { computed } from 'vue';
import AddToWishlist from "./AddToWishlist.vue";
import ProductImage from "./ProductImage.vue";
import ProductName from "./ProductName.vue";

const props = defineProps({
    products: {
        type: Array,
        required: true
    },
    label: {
        type: String,
        required: false,
        default: ''
    }
});

const products = computed(() => props.products ?? []);
</script>
<style scoped>
.product-tiles-title {
  font-size: var(--font-size-2xl);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  margin-bottom: var(--gap-20);
}
.product-tiles-wrapper {
  width: 100%;
  display: inline-grid;
  row-gap: 20px;
  margin-bottom: calc(var(--gap-20) * -1);
  column-gap: 20px;
  align-self: stretch;
  grid-template-rows: repeat(2,fit-content(100%));
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-auto-flow: row;
}

.recently-viewed-tiles-wrapper :deep(.single-wishlist-btn) {
  margin: 0 !important;
}

.product-tile {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: var(--br-12);
  border: 1px solid var(--border-color);
  background: var(--tertiary-color);
}

.product-tile .product-img-wrapper {
  width: 100%;
}

.product-tile .product-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: var(--gap-5);
  height: 45px;
}

.product-tile .product-name-wrapper {
  width: 100%;
  text-align: center;
  max-height: 40px;
}

.product-tile .product-name-wrapper a {
  text-decoration: none;
  color: var(--body-color);
  font-size: var(--font-size-md);
  font-weight: 400;
  line-height: 20px;
}

.product-icon-square-full {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--br-12);
}

@media screen and (min-width: 768px) {
  .product-tiles-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

</style>
